module.exports = __webpack_public_path__ + "img/prbk-mar25.70d5f3ae.png";